import React from "react";
import { PulseLoader } from "react-spinners";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import { deleteCouponAsync } from "../../../../redux/features/CouponSlice";

interface ConfirmDeleteCouponModalProps {
  isOpen: boolean;
  onClose: () => void;
  couponId: string;
  onDeleted?: () => void;
}

const ConfirmDeleteCouponModal: React.FC<ConfirmDeleteCouponModalProps> = ({
  isOpen,
  onClose,
  couponId,
  onDeleted,
}) => {
  const { deleting } = useAppSelector((state) => state.coupons);
  const dispatch = useAppDispatch();

  const handleDelete = async () => {
    try {
      await dispatch(deleteCouponAsync(couponId)).unwrap();
      toast.success("Coupon deleted successfully.");
      onDeleted?.();
      onClose();
    } catch (error: any) {
      toast.error(error?.message ?? "Failed to delete coupon.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg p-6 shadow-lg">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 text-red-600 rounded-full p-4">🗑️</div>
        </div>
        <h2 className="text-center text-xl font-semibold mb-2">
          Delete Coupon
        </h2>
        <p className="text-center text-gray-600 mb-6">
          Are you sure you want to delete this coupon? This action cannot be
          undone.
        </p>
        <div className="flex justify-between">
          <button
            onClick={onClose}
            className="w-1/2 bg-gray-100 text-gray-800 rounded-md py-2 px-4 mr-2 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="w-1/2 bg-red-600 text-white rounded-md py-2 px-4 hover:bg-red-700"
          >
            {deleting ? <PulseLoader size={6} color="#fff" /> : "Yes, Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteCouponModal;
